"use client";
import { useState, useEffect } from 'react';

const standard = {
    mobile: {
        min: -Infinity,
        max: 767,
    },
    tablet: {
        min: 768,
        max: 1023,
    },
    desktop: {
        min: 1024,
        max: Infinity,
    },
};
const expanded = Object.assign(Object.assign({}, standard), { mobileSmall: {
        min: -Infinity,
        max: 479,
    }, mobileLarge: {
        min: 480,
        max: 767,
    }, tabletSmall: {
        min: 768,
        max: 991,
    }, tabletLarge: {
        min: 992,
        max: 1023,
    }, desktopSmall: {
        min: 1024,
        max: 1600,
    }, desktopLarge: {
        min: 1601,
        max: 1920,
    }, desktopXLarge: {
        min: 1921,
        max: Infinity,
    } });
const windowMedia = (viewPortType, viewPortSize) => {
    if (typeof window !== 'undefined') {
        if (viewPortSize && viewPortType === 'expanded') {
            const expandedView = expanded[viewPortSize];
            switch (viewPortSize) {
                case 'mobile':
                case 'mobileSmall': {
                    return window.matchMedia(`(width <= ${expandedView.max}px)`);
                }
                case 'desktop':
                case 'desktopXLarge': {
                    return window.matchMedia(`(width >= ${expandedView.min}px)`);
                }
                default:
                    return window.matchMedia(`(width > ${expandedView.min}px) and (width <= ${expandedView.max}px)`);
            }
        }
        else
            switch (viewPortSize) {
                case 'mobile': {
                    return window.matchMedia(`(width <= ${standard.mobile.max}px)`);
                }
                case 'tablet': {
                    return window.matchMedia(`(width > ${standard[viewPortSize].min}px) and (width <= ${standard[viewPortSize].max}px)`);
                }
                case 'desktop': {
                    return window.matchMedia(`(width >= ${standard.desktop.min}px)`);
                }
            }
    }
};
const getStandardViewport = () => {
    if (typeof window !== 'undefined') {
        const { mobile, tablet } = standard;
        if (window.matchMedia(`(width <= ${mobile.max}px)`).matches)
            return 'mobile';
        if (window.matchMedia(`(width >= ${tablet.min}px) and (width <= ${tablet.max}px)`).matches)
            return 'tablet';
        return 'desktop';
    }
};
const getExpandedViewport = () => {
    const { mobile, mobileSmall, mobileLarge, tablet, tabletSmall, tabletLarge, desktop, desktopSmall, desktopLarge, desktopXLarge, } = expanded;
    if (typeof window !== 'undefined') {
        if (window.matchMedia(`(width <= ${mobileSmall.max}px)`).matches)
            return 'mobileSmall';
        if (window.matchMedia(`(width >= ${mobileLarge.min}px) and (width <= ${mobileLarge.max}px)`).matches)
            return 'mobileLarge';
        if (window.matchMedia(`(width <= ${mobile.max}px)`).matches)
            return 'mobile';
        if (window.matchMedia(`(width >= ${tabletSmall.min}px) and (width <= ${tabletSmall.max}px)`).matches)
            return 'tabletSmall';
        if (window.matchMedia(`(width >= ${tabletLarge.min}px) and (width <= ${tabletLarge.max}px)`).matches)
            return 'tabletLarge';
        if (window.matchMedia(`(width >= ${tablet.min}px) and (width <= ${tablet.max}px)`).matches)
            return 'tablet';
        if (window.matchMedia(`(width >= ${desktop.min}px) and (width <= ${desktop.max}px)`).matches)
            return 'desktop';
        if (window.matchMedia(`(width >= ${desktopSmall.min}px) and (width <= ${desktopSmall.max}px)`).matches)
            return 'desktopSmall';
        if (window.matchMedia(`(width >= ${desktopLarge.min}px) and (width <= ${desktopLarge.max}px)`).matches)
            return 'desktopLarge';
        if (window.matchMedia(`(width >= ${desktopXLarge.min}px)`).matches)
            return 'desktopXLarge';
    }
};
function useViewport(viewportSet, overrideViewport) {
    const [viewport, setViewport] = useState(undefined);
    const screenMedia = viewport ? windowMedia(viewportSet, viewport) : null;
    useEffect(() => {
        setViewport(viewportSet === 'expanded' ? getExpandedViewport : getStandardViewport);
    }, [viewportSet]);
    useEffect(() => {
        if (screenMedia) {
            screenMedia.onchange = () => {
                const newViewport = viewportSet === 'expanded'
                    ? getExpandedViewport()
                    : getStandardViewport();
                setViewport(newViewport);
            };
            // eslint-disable-next-line
            screenMedia.onchange;
        }
    }, [screenMedia, viewportSet, overrideViewport, viewport]);
    return overrideViewport || viewport;
}

export { useViewport as default };
